const mediaItems = [
  {
    title: '《星际穿越2》终极预告片',
    desc: '诺兰新作震撼来袭，太空史诗视觉盛宴',
    duration: '03:25',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20movie%20trailer%20thumbnail%20style%20with%20astronaut%20floating%20near%20wormhole%2C%20dramatic%20cosmic%20lighting%2C%20warm%20golden%20and%20deep%20space%20contrast%2C%20epic%20wide%20shot%2C%20movie%20poster%20quality&width=640&height=360&seq=media-trailer-1&orientation=landscape',
    alt: '星际穿越2预告片',
  },
  {
    title: '《长安十二时辰》精彩片段',
    desc: '第一集开篇长镜头，一秒穿越回大唐盛世',
    duration: '05:48',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20scene%20with%20Tang%20dynasty%20city%20at%20night%2C%20red%20lanterns%20and%20bustling%20streets%2C%20warm%20golden%20lighting%2C%20historical%20costume%20drama%20cinematography%2C%20epic%20scale&width=640&height=360&seq=media-clip-2&orientation=landscape',
    alt: '长安十二时辰精彩片段',
  },
  {
    title: '《了不起的挑战》爆笑名场面',
    desc: '第五季嘉宾互坑合集，笑到停不下来',
    duration: '08:12',
    views: '215万',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20comedic%20moment%20thumbnail%20with%20people%20laughing%20outdoors%2C%20bright%20sunny%20day%2C%20colorful%20and%20energetic%20atmosphere%2C%20warm%20vibrant%20tones%2C%20fun%20and%20entertaining%20composition&width=640&height=360&seq=media-clip-3&orientation=landscape',
    alt: '了不起的挑战爆笑名场面',
  },
  {
    title: '《鬼灭之刃》柱训练篇PV',
    desc: '最新篇章热血PV公开，柱全员集结出击',
    duration: '01:56',
    views: '342万',
    img: 'https://readdy.ai/api/search-image?query=Anime%20action%20scene%20thumbnail%20style%20with%20dynamic%20sword%20combat%2C%20fire%20effects%20in%20traditional%20Japanese%20art%20style%2C%20dramatic%20orange%20and%20dark%20contrast%2C%20energetic%20composition&width=640&height=360&seq=media-pv-4&orientation=landscape',
    alt: '鬼灭之刃柱训练篇PV',
  },
  {
    title: '《地球脉动III》企鹅特辑',
    desc: '南极帝企鹅生存实录，自然界的伟大奇迹',
    duration: '12:30',
    views: '89万',
    img: 'https://readdy.ai/api/search-image?query=Wildlife%20documentary%20thumbnail%20with%20penguins%20in%20Antarctic%20landscape%2C%20ice%20and%20snow%20scenery%2C%20soft%20natural%20light%2C%20cinematic%20nature%20photography%2C%20stunning%20polar%20environment&width=640&height=360&seq=media-nature-5&orientation=landscape',
    alt: '地球脉动III企鹅特辑',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-primary-500 uppercase tracking-wide mb-2">精彩片段</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">精彩片段</h2>
          <p className="mt-2 text-sm text-foreground-500">热门影视高光时刻，一睹为快</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-[1100px] mx-auto">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className={`group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative w-full ${idx === 0 ? 'aspect-[16/8]' : 'aspect-[16/9]'}`}>
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/25 group-hover:bg-foreground-950/35 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/75 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-2 right-2 px-2 py-0.5 rounded bg-background-50/90 text-foreground-800 text-xs font-medium whitespace-nowrap">
                  {item.views}次播放
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}